
import {useRef} from "react";

import {useNavigate} from "react-router-dom";

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

export default function Main() {

    const inputRef = useRef<HTMLInputElement>(null);
    const navigation = useNavigate();

    function goInvoice() {
        console.log(inputRef);
        navigation(`/invoiceNo/${inputRef.current?.value}`);
    }

    return (
        <>
            <Grid >
                <Typography variant="h6" gutterBottom>
                    운송장 배송 조회
                </Typography>
                <Grid >
                    <Grid item xs={12} md={8}>
                        <TextField
                            id="outlined-required"
                            label="운송장번호"
                            placeholder="운송장번호를 입력하세요"
                            defaultValue=""
                            fullWidth
                            color="success"
                            inputRef={inputRef}
                        />

                    </Grid>
                    <Grid>

                    </Grid>
                    <Stack spacing={4} direction="row">
                        <Button onClick={goInvoice} sx={{mt: 3, ml: 1}} color="primary"> 조회 </Button>
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
}
